module.exports = __webpack_public_path__ + "static/eamn-mainbg-81fe97af4bc53744f8c795d9271d4c41.svg";